import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { authService } from '@/app/core/auth/auth.service';

export const authGuard: CanActivateFn = async () => {
  if (authService.isAuthenticated()) return true;
  return inject(Router).createUrlTree(['/login']);
};
